// Get Serial Details Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {SerialDetails} from '../models/inventory.model';

export class GetSerialDetailsUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (serialNumber: string): Promise<SerialDetails> {
    return this.inventoryRepository.getSerialDetails(serialNumber);
  }
}
